import clientHOC from "../../client-hoc";
import {
  MeetingRecordingsView,
  PdfScopeBlock,
} from "../../../../components/shared";
import { convertToFullName } from "../../../../services/utils";

function clientPdfScope(clientDetails: any): PdfScopeBlock | undefined {
  if (!clientDetails) return undefined;
  const company = (clientDetails.company || "").trim();
  const name = convertToFullName(
    clientDetails.firstName,
    clientDetails.lastName
  ).trim();
  const title = (clientDetails.title || "").trim();
  if (!company && !name) return undefined;

  if (company) {
    const personLine = [name, title].filter(Boolean).join(" · ");
    return {
      primary: company,
      secondary: personLine || undefined,
    };
  }

  return {
    primary: name,
    secondary: title || undefined,
  };
}

function ClientMeetingRecordings({ clientDetails }: any) {
  return (
    <MeetingRecordingsView
      lockedClientId={clientDetails?.id}
      pdfScope={clientPdfScope(clientDetails)}
    />
  );
}

export default clientHOC(ClientMeetingRecordings);
